import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import $ from "jquery";
import { AuthProvider } from "./core/context/";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// oldUi
// Bootstrap Bundle JS
// import "bootstrap/dist/js/bootstrap.bundle.min";
// newUi
// import "bootstrap/dist/css/bootstrap.min.css";

import CommonLayout from "./Pages/siteTheme/CommonLayout.js";
// import ScrollToTop from "./Pages/siteTheme/v3/ScrollToup.jsx";

{/* <script src='https://cdn.jsdelivr.net/npm/apexcharts@2.1.2'></script> */}

function App() {
  const mode = localStorage.getItem("mode")
    ? localStorage.getItem("mode")
    : "light-new";

  const [theme, setTheme] = useState(mode);
  const [pageName, setPageName] = useState("");

  // $(window).scroll(function() {
  //   var scroll = $(window).scrollTop();
  //   if (scroll >= 60) {
  //     $('.bg-nav').addClass("fixed");
  //   } else {
  //     $('.bg-nav').removeClass("fixed");
  //   }
  // });

  useEffect(() => {
    if (theme == "dark" || theme == "dark-new") {
      $("body").addClass("dark-new");
      $("body").removeClass("light-new");
    } else {
      console.log("else")
      $("body").addClass("light-new");
      $("body").removeClass("dark-new");
    }
  }, [theme]);

  return (
    <AuthProvider>
      <div className={theme} id="themesection-body">
        <ToastContainer />
        <Router>
          <Routes>
            <Route path="*" name="Home" element={<CommonLayout
              setTheme={setTheme}
              theme={theme}
            />} />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;